/* eslint-disable react/jsx-props-no-spreading */
import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';
import PendingInvitationLetters from '../PendingInvitationLetters';
import BeneficiaryListMetricsCard from './BeneficiaryListMetricsCard';
import BeneficiaryListPercentCard from './BeneficiaryListPercentCard';

export type SummaryRow = {
  units: number;
  vestedUnits: number;
  incentiveValue: number;
};

type BeneficiaryListMetricsProps = {
  isAdmin: boolean;
  summaryRow: SummaryRow;
  pendingInvitations: any;
  percentVestedUnits: number;
};

const BeneficiaryListMetrics: FC<BeneficiaryListMetricsProps> = ({
  isAdmin,
  summaryRow,
  pendingInvitations,
  percentVestedUnits = 0,
}) => {
  const { t } = useTranslate();

  return (
    <div className="nk-block mb-4 row">
      <div className="col-12 col-lg-8">
        <div className="card card-bordered card-stretch mb-4 mb-lg-0">
          <div className="card-inner">
            <h6 className="overline-title-alt mb-2">
              <em className="icon ni ni-layers mr-2 fs-20px" />
              {t('UnitsSummary')}
            </h6>

            <div className="row text-center">
              <BeneficiaryListMetricsCard
                title={t('UnitsAssigned')}
                value={summaryRow?.units || 0}
              />

              <BeneficiaryListMetricsCard
                title={t('UnitsVested')}
                value={summaryRow?.vestedUnits || 0}
              />

              <BeneficiaryListMetricsCard
                title={t('IncentiveValue')}
                value={summaryRow?.incentiveValue || 0}
                useDecimals
                suffix="€"
              />

              {isAdmin && (
                <PendingInvitationLetters
                  pendingInvitations={pendingInvitations}
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="col-12 col-lg-4">
        <BeneficiaryListPercentCard percentVestedUnits={percentVestedUnits} />
      </div>
    </div>
  );
};

export default BeneficiaryListMetrics;
